import React from "react";
import "../assets/css/home.css";

function Home() {
  return (
    <div className="home-logo-pattern">
      <div className="home-diagonal-div">
        <div className="home-container-text">
          <p className="home-welcome-to">Welcome to the</p>
          <h1 className="home-title">Home of Electric</h1>
        </div>
      </div>
    </div>
  );
}

export default Home;
